import { moduleConfig } from 'src/app/core/models/module-config';
import { NavbarItem } from 'src/app/rokezzz/panel-menu/api/navbar-item';

export const navbarItems: NavbarItem[] = [
    {
        icon: 'home',
        name: $localize`Home`,
        path: 'admin.dashboard',
    },
    ...(moduleConfig.isBlogEnabled ? [{
        icon: 'insert_comment',
        name: $localize`Blog`,
        children: [
            ...(moduleConfig.blogHasCategory ? [{
                name: $localize`Kategorie`,
                path: 'admin.blog.category',
            }] : []),
            {
                name: $localize`Wpisy`,
                path: 'admin.blog.post',
            },
        ]
    }] : []),
    ...(moduleConfig.isProductEnabled ? [{
        icon: 'shopping_cart',
        name: $localize`Oferta`,
        children: [
            {
                name: $localize`Kategorie`,
                path: 'admin.offer.product-category',
            },
            {
                name: $localize`Kategorie archiwalne`,
                path: 'admin.offer.product-category-archived',
            },
            {
                name: $localize`Produkty`,
                path: 'admin.offer.product',
            },
            {
                name: $localize`Produkty archiwalne`,
                path: 'admin.offer.product-archived',
            },
        ]
    }] : []),
    ...(moduleConfig.isSettingsEnabled ? [
        {
            icon: 'folder',
            name: $localize`Zawartość`,
            children: [
                {
                    name: $localize`Strona główna`,
                    path: 'admin.content.home',
                },
                {
                    name: $localize`O firmie`,
                    path: 'admin.content.about',
                },
                {
                    name: $localize`Oferta`,
                    path: 'admin.content.offer',
                },
                {
                    name: $localize`Promocja`,
                    path: 'admin.content.promotion',
                },
                {
                    name: $localize`Filia dziecięca`,
                    path: 'admin.content.childrenBranch',
                },
                {
                    name: $localize`Kontakt`,
                    path: 'admin.content.contact',
                },
                {
                    name: $localize`Regulaminy`,
                    path: 'admin.content.regulations',
                },
            ]
        },
        {
            icon: 'image',
            name: $localize`Obrazki`,
            path: 'admin.image.list',
        }
    ] : []),
    ...(moduleConfig.isNewsletterEnabled ? [{
        icon: 'mail',
        name: $localize`Newsletter`,
        path: 'admin.newsletter',
    }] : []),
    ...(moduleConfig.isReservationEnabled ? [
        {
            icon: 'event_note',
            name: $localize`Rezerwacje`,
            path: 'admin.reservation.list',
        },
        {
            icon: 'event',
            name: $localize`Grafik`,
            path: 'admin.schedule.list',
        }
    ] : []),
    {
        icon: 'settings',
        name: $localize`Ustawienia`,
        children: [
            {
                name: $localize`Hasło`,
                path: 'admin.settings.password',
            },
            ...(moduleConfig.isDeleteUserOptionEnabled ? [{
                name: $localize`Zaawansowane`,
                path: 'admin.settings.advanced',
            }] : []),
        ]
    }
];
